<template>
<br />
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import router from '@/router'
import store from '@/store'

export default {
  name: 'Home',
  components: {},

  props: {
    isShowLogoutAlert: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {}
  },

  computed: {
    ...mapState('client', [
      'authClient'
    ]),
    ...mapState('currentUser/permissions', [
      'permissions'
    ]),
    ...mapGetters('client', [
      'accessToken'
    ])
  },

  watch: {
    async permissions (newVal) {
      if (newVal !== undefined) {
        this.redirectPage(newVal)
      }
    }
  },

  created () {},
  async mounted () {
    const documentURL = new URL(document.location)
    if (documentURL.searchParams.get('code')) {
      await store.dispatch('currentUser/tokens/createAccessToken', documentURL.searchParams.get('code'))
      await Promise.all(
        store.dispatch('currentUser/get'),
        store.dispatch('currentUser/permissions/list')
      )
    }

    if (!this.accessToken) {
      router.replace({
        name: 'SignIn'
      })
    }
    this.redirectPage(this.permissions)
  },
  updated () {},
  destroyed () {},

  methods: {
    redirectPage (permissions) {
      if (permissions !== undefined) {
        if (permissions.length > 0) {
          router.replace({
            name: 'ManagementHome'
          })
        } else {
          router.replace({
            name: 'Profile'
          })
        }
      }
    }
  }
}
</script>
